var Dropdown = {
  handleOther: function(controlId, otherId) {
    var value = $('#' + controlId + " option:selected").val();

    if (value === "Other") {
      $('#' + otherId).addClass('visible seen');
      $('#' + otherId).removeClass('hidden');
      $('#' + otherId).attr("name", $('#' + controlId).attr("name"));
    } else {
      $('#' + otherId).addClass('hidden');
      $('#' + otherId).removeClass('visible seen');
      $('#' + otherId).attr("name", '');


    }
  },

  checkOther: function(controlId, otherId, answer, standardField) {
    if(standardField) {
      // check if answer isn't in dropdown
      if($('#' + controlId).find('option[value="' + answer + '"]').length === 0) {
        $('#' + controlId).val("Other");
        Dropdown.handleOther(controlId, otherId);
        $('#' + otherId).val(answer);
      } else {
        $('#' + otherId).attr("name", '');
      }
    }
  }
};

global.Dropdown = global.Dropdown || Dropdown;
